import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/summary/img2.png'
import _imports_1 from '@/assets/image/summary/sum_title.png'


const _withScopeId = n => (_pushScopeId("data-v-2298e56f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary-index" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "leftImg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_5 = { class: "richText" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"sum_title\" data-v-2298e56f><img src=\"" + _imports_1 + "\" alt=\"\" data-v-2298e56f></div><div class=\"title\" data-v-2298e56f><span class=\"t1\" data-v-2298e56f>律所概述</span><span class=\"t2\" data-v-2298e56f>ABOUT US</span></div>", 2)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", {
            class: "text",
            innerHTML: _ctx.mobile ? _ctx.m_text : _ctx.text
          }, null, 8, _hoisted_8)
        ])
      ]),
      _hoisted_9
    ])
  ]))
}